import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import Button from './Button';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
  message?: string;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
  message = 'Something went wrong'
}) => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <div className="flex items-center justify-center mb-4">
        <AlertTriangle className="h-12 w-12 text-red-500" />
      </div>
      
      <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
        {message}
      </h2>
      
      <p className="text-gray-600 mb-6 text-center">
        We apologize for the inconvenience. Please try again or contact support if the problem persists.
      </p>

      <div className="flex justify-center">
        <Button
          onClick={resetErrorBoundary}
          className="flex items-center"
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Try Again
        </Button>
      </div>

      {process.env.NODE_ENV === 'development' && (
        <pre className="mt-6 p-4 bg-gray-50 rounded text-sm text-red-600 overflow-auto">
          {error.message}
          {error.stack}
        </pre>
      )}
    </div>
  );
};

export default ErrorFallback;